import { Alert, Grid, Typography } from '@mui/material';
import React from 'react';

interface SummaryAlertsProps {
  totalValidEntries: number;
  totalInvalidEntries: number;
  totalLines: number;
}

const SummaryAlerts: React.FC<SummaryAlertsProps> = ({
  totalValidEntries,
  totalInvalidEntries,
  totalLines,
}) => {
  if (totalValidEntries === 0 && totalInvalidEntries === 0) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="body2">
          <strong>Resumen:</strong> {totalValidEntries} asientos válidos |{' '}
          {totalInvalidEntries} asientos con errores | {totalLines} líneas en
          total
        </Typography>
      </Alert>
      {totalInvalidEntries > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            Se encontraron {totalInvalidEntries} asientos con errores que deben
            ser corregidos antes de importar.
          </Typography>
        </Alert>
      )}
    </Grid>
  );
};

export default SummaryAlerts;
